declare const __LK_EXECUTOR_WEB_BASE_URL__: string | undefined;

/**
 * Base URL for executor_web API. In the lk app, Vite `define` sets `__LK_EXECUTOR_WEB_BASE_URL__`
 * at build time from `API_URL` (prod) or `/executor_web` via Vite split proxy (dev: jakku + lk tasks). Override: `VITE_LK_EXECUTOR_WEB_BASE`.
 */
export function getExecutorWebBaseUrl(): string {
	if (typeof __LK_EXECUTOR_WEB_BASE_URL__ === 'string' && __LK_EXECUTOR_WEB_BASE_URL__.length > 0) {
		return __LK_EXECUTOR_WEB_BASE_URL__;
	}
	return '/executor_web';
}
